// Single source of truth for the AI disclaimer wording (approved by Michael, 2026-09-23).
// Hardcoded on purpose: never generated by the model, never fetched from translations.
// Any wording change is a one-line edit here.
export const AI_DISCLAIMER_TEXT = {
  hebrew:
    "התוצרים הופקו באמצעות בינה מלאכותית על בסיס הטקסט שהוזן בלבד, ועלולים לכלול טעויות. הם נועדו לתמוך בהחלטה הקלינית ואינם מחליפים את שיקול הדעת המקצועי. יש לאמת כל ממצא מול הציטוט המקורי.",
  english:
    "These results were generated by AI from the submitted text only and may contain errors. They are intended to support clinical decision-making and do not replace professional judgment. Verify each finding against the original quote.",
} as const;

export type TAiDisclaimerLanguage = keyof typeof AI_DISCLAIMER_TEXT;

// hebrew → Hebrew, english → English, missing or anything else → Hebrew.
export const resolveAiDisclaimerLanguage = (
  outputLanguage: string | null | undefined
): TAiDisclaimerLanguage => {
  const normalized = (outputLanguage ?? "").trim().toLowerCase();
  if (normalized === "english") return "english";
  return "hebrew";
};
